import useConfigureDiscussion from '../../discussions/use-configure-discussion'
import useCourseDiscussionTopic from './use-course-discussion-topic'

const useDiscussExperience = ({
    experience = {},
    users = [],
}) => {
    const {topic} = useCourseDiscussionTopic({ course: experience })

    const {
        showDiscussionConfiguration
    } = useConfigureDiscussion({ topic, users })

    return {
        showDiscussionConfiguration
    }
}

export default useDiscussExperience
